import * as React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { AuthGuard } from "@/components/auth/auth-guard";
import { Layout as DashboardLayout } from "@/components/dashboard/layout/layout";

export const route = {
	path: "dashboard",
	element: (
		<AuthGuard>
			<DashboardLayout>
				<Outlet />
			</DashboardLayout>
		</AuthGuard>
	),
	children: [
		{ index: true, element: <Navigate replace to="wealth-insider" /> },
		{
			path: "wealth-insider",
			children: [
				{
					index: true,
					lazy: async () => {
						const { Page } = await import("@/pages/dashboard/wealth-insider/overview");
						return { Component: Page };
					},
				},
				{
					path: "reports",
					children: [
						{
							index: true,
							lazy: async () => {
								const { Page } = await import("@/pages/dashboard/wealth-insider/reports/list");
								return { Component: Page };
							},
						},
						{
							path: ":reportId",
							lazy: async () => {
								const { Page } = await import("@/pages/dashboard/wealth-insider/reports/details");
								return { Component: Page };
							},
						},
					],
				},
				{
					path: "algorithms",
					lazy: async () => {
						const { Page } = await import("@/pages/dashboard/wealth-insider/algorithms");
						return { Component: Page };
					},
				},
				{
					path: "universes",
					lazy: async () => {
						const { Page } = await import("@/pages/dashboard/wealth-insider/universes");
						return { Component: Page };
					},
				},
				{
					path: "schedules",
					lazy: async () => {
						const { Page } = await import("@/pages/dashboard/wealth-insider/schedules");
						return { Component: Page };
					},
				},
				{
					path: "activity",
					lazy: async () => {
						const { Page } = await import("@/pages/dashboard/wealth-insider/activity");
						return { Component: Page };
					},
				},
			],
		},
	],
};
